export const createExcelFile = (filename) => {
  const file = new File([], `${filename}.xlsx`, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  return file;
};
